import { useMemo } from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { Marker, Polyline, Popup, useMapEvents, GeoJSON } from "react-leaflet";
import { divIcon, DomEvent, icon } from "leaflet";
import hash from "object-hash";
import { lineString } from "@turf/helpers";
import bezierSpline from "@turf/bezier-spline";
import { STATIONS_COLOR, STATIONS_SIZE } from "Configs/map";
import { STATIONS } from "Constants/Stations";

import { Box, Button, Card, Stack, Typography } from "@mui/material";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";

import { changePointPosition, removePoint } from "Redux/pointsSlice";
import DestinationIcon from "Assets/Images/Survey/destination-icon.svg";
import SourceIcon from "Assets/Images/Survey/source-icon.svg";
import { LOGO } from "Configs/core";
import { changeSelectLocMode } from "Redux/mapSlice";

const ICON_SIZE = 25;

export default function AddSurvayLoc() {
  const dispatch = useAppDispatch();
  const { selectedLoc, selectLocMode, selectLocFor, stationLoc } = useAppSelector((state) => state.map);
  const { data } = useAppSelector((state) => state.modal);

  const sourceIcon = icon({ iconUrl: SourceIcon, iconSize: [ICON_SIZE, ICON_SIZE] });
  const destinationIcon = icon({ iconUrl: DestinationIcon, iconSize: [ICON_SIZE, ICON_SIZE] });

  const surveyMarkers = useMemo(() => {
    if (selectLocFor === "add-survay") {
      const finalResult = [];

      const latLng1 = [selectedLoc[0].lat, selectedLoc[0].lng];
      const latLng2 = [selectedLoc[1].lat, selectedLoc[1].lng];

      const offsetX = latLng2[1] - latLng1[1];
      const offsetY = latLng2[0] - latLng1[0];

      const r1 = Math.sqrt(offsetX ** 2 + offsetY ** 2);
      const theta = Math.atan2(offsetY, offsetX);

      const thetaOffset = 3.14 / 20;

      const r2 = r1 / 2 / Math.cos(thetaOffset);
      const theta2 = theta + thetaOffset;

      const midpointX = r2 * Math.cos(theta2) + latLng1[1];
      const midpointY = r2 * Math.sin(theta2) + latLng1[0];

      const midpointLatLng = [midpointY, midpointX];

      finalResult.push(latLng1, midpointLatLng, latLng2);

      const line = lineString(finalResult.map((latLng) => [latLng[1], latLng[0]]));
      const curved: any = bezierSpline(line, { sharpness: 1, resolution: 10000 });

      return (
        <>
          {selectLocMode === 3 || selectLocMode === 2 ? (
            <Marker
              position={[selectedLoc[0].lat, selectedLoc[0].lng]}
              icon={sourceIcon}
              // eventHandlers={events}
              opacity={1}
            />
          ) : null}

          {selectLocMode === 3 ? (
            <Marker
              position={[selectedLoc[1].lat, selectedLoc[1].lng]}
              icon={destinationIcon}
              // eventHandlers={events}
              opacity={1}
            />
          ) : null}
          {selectLocMode === 3 ? (
            <>
              {" "}
              <Polyline
                positions={[
                  [selectedLoc[0].lat, selectedLoc[0].lng],
                  [selectedLoc[1].lat, selectedLoc[1].lng],
                ]}
                pathOptions={{ opacity: 0.2, color: "#000", weight: 5 }}
                opacity={1}
              />
              <GeoJSON data={curved} pathOptions={{ weight: 5, color: "#0E1232", opacity: 1 }} key={hash(curved)} />
            </>
          ) : null}
        </>
      );
    }
    if (selectLocFor === "add-station") {
      // const stationColor = data?.type ? STATIONS_COLOR[data?.type:any] : " ";
      const stationData = STATIONS.filter((i) => i.type === data?.type)[0];
      const iconMarkup = renderToStaticMarkup(
        <Box
          style={{
            width: `${STATIONS_SIZE}px`,
            height: `${STATIONS_SIZE}px`,
            backgroundColor: "red",
            borderRadius: "50%",
            border: "4px solid #F5F5F5",
            display: "grid",
            placeItems: "center",
            color: "#fff",
            // filter: ids.includes(station.id) ? "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))" : "",
          }}
        >
          {stationData.icon}
        </Box>
      );
      const icon2 = divIcon({
        html: iconMarkup,
        iconAnchor: [STATIONS_SIZE / 2, STATIONS_SIZE / 2],
      });

      return (
        <>
          {selectLocMode === 2 ? (
            <Marker
              position={[stationLoc.lat, stationLoc.lng]}
              icon={icon2}
              // eventHandlers={events}
              opacity={1}
            />
          ) : null}
        </>
      );
    }
  }, [selectedLoc, selectLocMode]);

  return <>{surveyMarkers}</>;
}
